import React, { useEffect, useState, useRef } from "react";
import "./Modal.css";
//import AvatarSelectionModal from "./components/AvatarSelectionModal";
import CopilotWebChat from "./components/CopilotWebChat";
import ReactPlayer from "react-player";

const Modal = ({
  show,
  onClose,
  title,
  content,
  avatar,
  image,
  isFullScreen,
  videoSrc,
  onNext,
  onPrev,
  currentStage,
}) => {
  const [visible, setVisible] = useState(false);
  const bottomContentRef = useRef(null);
  const [fullscreenVideo, setFullScreenVideo] = useState(false);
  const [showPopUp, setShowPopUp] = useState(false); // State for pop-up visibility

  const handleScrollToBottom = () => {
    bottomContentRef.current.scrollIntoView({ behavior: "smooth" });
  };

  const handleShowPopUp = () => {
    setShowPopUp(true);
  };

  const handleClosePopUp = () => {
    setShowPopUp(false);
  };

  const handleNext = () => {
    setShowPopUp(false); // Hide pop-up on next click
    onNext(); // Call the original onNext function
  };

  const handlePrevious = () => {
    setShowPopUp(false); // Hide pop-up on next click
    onPrev(); // Call the original onNext function
  };

  const [showChat, setShowChat] = useState(false);

  // Function to toggle chat modal visibility
  const toggleChat = () => {
    setShowChat(!showChat);
    setShowPopUp(false);
  };

  useEffect(() => {
    if (show) {
      setVisible(true);

      setShowPopUp(false);
      // setShowAvatarModal(true); // Ensure avatar modal is shown initially
    } else {
      const timer = setTimeout(() => setVisible(false), 300); // Match the transition duration
      return () => clearTimeout(timer);
    }
  }, [show]);

  /*
  const handleSelectAvatar = (avatar) => {
    console.log("Avatar selected:", avatar); // Debugging log
    setSelectedAvatar(avatar);
    setShowAvatarModal(false);
  };
*/
  if (!visible) {
    return null;
  }
  //   const openQuizlet = () => {
  //     const iframe = document.createElement("iframe");
  //     iframe.src = `${process.env.PUBLIC_URL}/copilot.html`;
  //     iframe.style.width = "100%";
  //     iframe.style.height = "100%";
  //     iframe.style.border = "none";
  //     document.body.appendChild(iframe);
  // };
  return (
    <>
      <div className={`modal-overlay ${show ? "show" : ""}`}>
        <div
          className={`modal-content ${show ? "show" : ""} ${
            isFullScreen ? "full-screen" : ""
          }`}
        >
          <button className="modal-translate">
            <img
              src={`${process.env.PUBLIC_URL}/translate-globe.png`}
              alt="Translate"
              className="translate-icon"
            />
          </button>
          <button className="modal-copilot" onClick={toggleChat}>
            <img
              src={`${process.env.PUBLIC_URL}/quiz.jpg`}
              alt="Quizlets"
              className="quizlet-icon"
            />
          </button>
          <button className="modal-close" onClick={onClose}>
            <div className="tooltip-container">
              <img src={avatar} alt="Close" className="selected-avatar" />
              <span className="tooltip-text">Exit</span>
            </div>
          </button>

          {isFullScreen && (
            <div>
              <img src={image} alt={title} className="modal-image" />
              <div className="modal-buttons">
                {currentStage != 0 && (
                  <button className="modal-prev" onClick={handlePrevious}>
                    Go Back
                  </button>
                )}
                <button className="modal-next" onClick={handleNext}>
                  Next
                </button>
                <button className="open-popup-button" onClick={handleShowPopUp}>
                  Want to know more?
                </button>
              </div>
            </div>
          )}
          {videoSrc && (
            <div className="modal-video">
              <ReactPlayer url={videoSrc} controls className="video-overlay" />
            </div>
          )}
        </div>
      </div>
      <div className="below-modal" ref={bottomContentRef}>
        <p dangerouslySetInnerHTML={{ __html: content }}></p>
      </div>
      {showPopUp && (
        <div className="popup-overlay">
          <div className="popup-content">
            <button className="close-popup-button" onClick={handleClosePopUp}>
              &times;
            </button>
            <p dangerouslySetInnerHTML={{ __html: content }}></p>
          </div>
        </div>
      )}

      {showChat && (
        <div className="chat-modal">
          <button className="close-button" onClick={toggleChat}>
            &times;
          </button>
          <CopilotWebChat />
        </div>
      )}
    </>
  );
};

export default Modal;
